import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

export function addGameMentionTooltip() {
    let tooltip = null;
    let hideTimeout = null;

    function showTooltip(target) {
        const description = target.getAttribute('data-description');
        const imageUrl = target.getAttribute('data-image');

        if (!description && !imageUrl) return;

        clearTimeout(hideTimeout);

        if (tooltip) tooltip.remove();

        tooltip = document.createElement('div');
        tooltip.className = 'GameMention-tooltip';

        if (imageUrl) {
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = '';
            tooltip.appendChild(img);
        }
        if (description) {
            const p = document.createElement('p');
            p.textContent = description;
            tooltip.appendChild(p);
        }

        document.body.appendChild(tooltip);

        // Position above the mention link
        const rect = target.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        let top = rect.top - tooltipRect.height - 8 + window.scrollY;
        let left = rect.left + (rect.width / 2) - (tooltipRect.width / 2) + window.scrollX;

        // Keep within viewport
        left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));
        if (top < window.scrollY) {
            top = rect.bottom + 8 + window.scrollY;
        }

        tooltip.style.top = top + 'px';
        tooltip.style.left = left + 'px';

        // Allow hovering the tooltip itself
        tooltip.addEventListener('mouseenter', function () {
            clearTimeout(hideTimeout);
        });
        tooltip.addEventListener('mouseleave', function () {
            scheduleHide();
        });
    }

    function scheduleHide() {
        hideTimeout = setTimeout(function () {
            if (tooltip) {
                tooltip.remove();
                tooltip = null;
            }
        }, 200);
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function escapeAttr(text) {
        return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    extend(CommentPost.prototype, 'oncreate', function () {
        this.$('.GameMention').on('mouseenter', function () {
            showTooltip(this);
        }).on('mouseleave', function () {
            scheduleHide();
        });
    });

    extend(CommentPost.prototype, 'onupdate', function () {
        this.$('.GameMention').off('mouseenter mouseleave')
            .on('mouseenter', function () {
                showTooltip(this);
            }).on('mouseleave', function () {
                scheduleHide();
            });
    });
}
